// TOP LEVEL IMPORTS
import React from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements';
// ANTD
import Form from 'antd/lib/form'; // for js
import Row from 'antd/lib/row'; // for js
import Col from 'antd/lib/col'; // for js
import message from 'antd/lib/message';
import notification from 'antd/lib/notification';
// APOLLO
import { compose, graphql } from 'react-apollo';
import payInvoice from 'ApolloClient/Mutations/payInvoice';
// COMPONENTS
import SubmitButton from './SubmitButton';
import ErrorHelpers from 'lib/helpers/ErrorHelpers/index';
import StripeErrors from './StripeErrors';

// CONSTANTS & DESTRUCTURING
// ===================================
const FormItem = Form.Item;

const PAYMENT_ERRORS = {
  stripe: {
    basic: {
      message: 'Trouble with Stripe Payments...',
      duration: 7,
      description:
        'Please confirm your card number is correct (card #, expiration, area code, etc.). If you are still having trouble, please contact us.',
    },
  },
};

// EXPORTED COMPONENT
// ===================================
class PaymentForm extends React.Component {
  state = {
    disabled: false,
    stripeError: '',
    loading: false,
    paid: false,
  };

  clearState = () => {
    this.setState({
      disabled: false,
      stripeError: '',
      loading: false,
      paid: false,
    });
  };

  handleNoToken = () => notification.error(PAYMENT_ERRORS.stripe.basic);

  payInvoiceWithStripe = token => {
    let variables = this.getPayInvoiceVariables(token);
    return this.props.payInvoice({ variables });
  };

  onSuccessfulPayment = () => {
    this.setState({ loading: false, paid: true });
    message.success('Successfully paid!', 4);
    window.location.reload();
  };

  getStripeToken = async () => {
    const { createToken } = this.props.stripe;
    let stripeResponse;

    try {
      stripeResponse = await createToken({});
    } catch (err) {
      console.log(err);
      this.clearState();
      return ErrorHelpers.handleError(err);
    }

    // check for error in stripeResponse
    if (stripeResponse.error) {
      this.clearState();
      ErrorHelpers.handleError(stripeResponse.error);
      return null;
    }

    if (!stripeResponse.token || !stripeResponse.token.id) {
      let newError = new Error('no-token');
      this.clearState();
      ErrorHelpers.handleError(newError);
      return null;
    }

    return stripeResponse.token;
  };

  getPayInvoiceVariables = token => {
    const params = { token: token.id };

    return {
      _id: this.props.invoice._id,
      params,
    };
  };

  handleSubmit = async evt => {
    evt.preventDefault(); // We don't want to let default form submission happen here, which would refresh the page.

    this.setState({ loading: true });

    let res;
    let token = await this.getStripeToken();

    // exit if we don't get a token back.
    if (!token) {
      return null;
    }

    try {
      res = await this.payInvoiceWithStripe(token);
    } catch (err) {
      this.clearState();
      console.log(err);
      return ErrorHelpers.handleError(err);
    }
    return this.onSuccessfulPayment();
  };

  render() {
    const { stripeError } = this.state;
    const { finalPaymentAmount } = this.props.invoice;

    if (this.state.paid) {
      return null;
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={20} type="flex" align="middle" justify="center">
          <Col xs={24}>
            <FormItem>
              <React.Fragment>
                <label htmlFor="cardnumber">
                  Card details
                  <CardElement style={{ base: { fontSize: '18px' } }} />
                </label>
              </React.Fragment>
            </FormItem>
          </Col>
          <Col xs={24}>
            <SubmitButton
              loading={this.state.loading}
              amount={finalPaymentAmount}
              currencySymbol={this.props.currencySymbol}
            />
          </Col>
          <Col xs={24}>
            <StripeErrors stripeError={stripeError} />
          </Col>
        </Row>
      </Form>
    );
  }
}

export default compose(graphql(payInvoice, { name: 'payInvoice' }))(injectStripe(PaymentForm));



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/PaymentFormArea/PaymentFormContainer/PaymentForm/index.js